module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-dash-fill-5cd87c9f.svg";